var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.MULTIBILL_EDIT.show ? _c('div', {
    directives: [{
      name: "preventWindowScrolling",
      rawName: "v-preventWindowScrolling"
    }],
    staticClass: "modal-conteiner",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event);
      }
    }
  }, [_c('div', {
    staticClass: "modal-frame",
    class: {
      'shown': _vm.isShown
    }
  }, [_c('div', {
    staticClass: "modal-inner-container"
  }, [_c('div', [_c('div', [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleChangeAmount($event);
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('change.bill.amount')))])]), _c('labeled-input', {
    attrs: {
      "label": _vm.$t('enter.new.amount', {
        getCurrencySign: _vm.currency.sign
      }),
      "placeholder": "0 ".concat(_vm.currency.sign),
      "error": _vm.$v.amount.$error,
      "force-replace": [[/[^0-9\.\,]+/g, ''], [/^\./g, ''], [/\,/, '\.']],
      "force-format": [_vm.$formatInputAmount({
        significantZeros: _vm.currency.significant_zeros,
        decimalsSeparator: '.',
        thousandSeparator: ' '
      })]
    },
    on: {
      "focus": _vm.$v.amount.$reset,
      "blur": _vm.$v.amount.$touch
    },
    model: {
      value: _vm.amount,
      callback: function callback($$v) {
        _vm.amount = $$v;
      },
      expression: "amount"
    }
  })], 1)]), _c('div', {
    staticClass: "buttons_wrapper"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.isValid
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.handleChangeAmount($event);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('button', {
    staticClass: "button blank",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.close($event);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.cancel')))])])])])])])])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }